import React from 'react';
import client from 'ApolloClient/index.js';
import activityLogs from 'ApolloClient/Queries/activityLogs';
import DownloadCSV from 'components/common/DownloadCSV';
import Button from 'components/common/Button';
import PageContainer from 'components/common/PageContainer';

class AdminActivityLogs extends React.PureComponent {
  state = {
    loading: false,
    activityLogs: false,
  };

  onDownload = async () => {
    this.setState({ loading: true });
    let res = await client.query({
      query: activityLogs,
    });
    console.log({
      activityLogs: res.data.activityLogs,
    });
    this.setState({ loading: false, activityLogs: res.data.activityLogs });
  };

  render() {
    return (
      <PageContainer>
        <div style={{ width: 200, marginBottom: 20 }}>
          <Button loading={this.state.loading} onClick={this.onDownload}>
            Download Activity Logs
          </Button>
        </div>
        <div style={{ width: 200 }}>
          {this.state.activityLogs && <DownloadCSV dataSource={this.state.activityLogs} />}
        </div>
      </PageContainer>
    );
  }
}

export default AdminActivityLogs;



// WEBPACK FOOTER //
// ./src/routes/admin-activity-logs/index.js